import { Icon } from "@opendash/icons";
import { observer } from "mobx-react-lite";
import React from "react";

type Props = {
  color?: string;
  style?: React.CSSProperties;
};

export const StateCircleIcon = observer((props: Props) => {
  return (
    <Icon icon="fa:solid:dot-circle" color={props.color} style={props.style} />
  );
});
